import { Card, Tabs } from "antd";
import React from "react";
import { Link } from "react-router-dom";

function Settings({ token }) {
  return (
    <div style={{ width: "100%", height: "100%" }}>
      <Tabs
        defaultActiveKey={1}
        items={[
          {
            key: 1,
            label: "Интеграции",
            children: (
              <div
                style={{
                  display: "flex",
                  gap: "20px",
                  flexWrap: "wrap",
                  alignItems: "flex-start",
                }}
              >
                <Link to={`amo_triggers?token=${token}`}>
                  <Card
                    hoverable
                    style={{
                      width: 300,
                      minHeight: 350,
                    }}
                    cover={
                      <div
                        style={{
                          display: "flex",
                          height: 200,
                          justifyContent: "center",
                          alignItems: "center",
                          backgroundColor: "lightblue",
                          color: "white",
                        }}
                      />
                    }
                  >
                    <Card.Meta
                      title="amoCRM триггеры"
                      description="создание, редактирование и администрирование триггеров уведомлений для salesBot amoCRM"
                    />
                  </Card>
                </Link>

                <Link to={`/settings/cashbox_settings?token=${token}`}>
                  <Card
                    hoverable
                    style={{
                      width: 300,
                      minHeight: 350,
                    }}
                    cover={
                      <div
                        style={{
                          display: "flex",
                          height: 200,
                          justifyContent: "center",
                          alignItems: "center",
                          backgroundColor: "lightgreen",
                          color: "white",
                        }}
                      />
                    }
                  >
                    <Card.Meta
                      title="Настройки кассы"
                      description="включение/отключение проверки фото при списании, другие параметры кассы"
                    />
                  </Card>
                </Link>
              </div>
            ),
          },
        ]}
      />
    </div>
  );
}

export default Settings;
